module.exports = __webpack_public_path__ + "public/images/header/welcome.9ccb786c7b0e9364883c110989861bcb.svg";